// 价格工具函数

/**
 * 格式化价格为显示格式
 * @param {string|number} price - 价格值
 * @returns {string} 格式化后的价格字符串
 */
export const formatPrice = (price) => {
  // 如果价格已经是格式化的字符串（如 "S$22.90"），直接返回
  if (typeof price === 'string') {
    return price;
  }
  
  // 如果价格是数字，格式化为 "S$" 格式
  if (typeof price === 'number') {
    return `S$${price.toFixed(2)}`;
  }
  
  // 如果价格无效，返回默认值
  return 'S$0.00';
};

/**
 * 从格式化的价格字符串中提取数字值
 * @param {string} priceString - 格式化的价格字符串（如 "S$22.90"）
 * @returns {number} 提取的数字值
 */
export const extractPriceValue = (priceString) => {
  if (typeof priceString === 'number') {
    return priceString;
  }
  
  if (typeof priceString === 'string') {
    // 移除 "S$" 前缀并转换为数字
    const numericValue = priceString.replace(/^S\$/, '');
    return parseFloat(numericValue) || 0;
  }
  
  return 0;
};

/**
 * 计算两个价格的差值
 * @param {string|number} price1 - 第一个价格
 * @param {string|number} price2 - 第二个价格
 * @returns {string} 格式化后的差值
 */
export const calculatePriceDifference = (price1, price2) => {
  const value1 = extractPriceValue(price1);
  const value2 = extractPriceValue(price2);
  const difference = value1 - value2;
  
  return formatPrice(difference);
};

/**
 * 计算价格乘以数量
 * @param {string|number} price - 价格
 * @param {number} quantity - 数量
 * @returns {string} 格式化后的总价
 */
export const calculateTotalPrice = (price, quantity) => {
  const priceValue = extractPriceValue(price);
  const total = priceValue * quantity;
  
  return formatPrice(total);
};
